module.exports = __webpack_public_path__ + "img/snc.797fe8ed.jpg";